/*=========================================================================================
  File Name: moduleKindsState.js
  Description: Kinds Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  listStatus: [],
  infoDB: {}
}
